<template>
  <div class="container mt-4 mb-4">
    <form>
      <div class="card mx-auto" style="width:70%;">
        <div class="card-body">
          <div class="form-group row mt-4 mb-4">
            <label for="owner-email" class="col-sm-3 col-form-label">Owner (E-mail Address)</label>
            <div class="col-sm-9">
	      <input type="text" class="form-control" id="owner-email" name="owner-email" placeholder="@graphtec.co.jp" v-model="search_params.email_address">
            </div>
          </div>
          <div class="form-group row mt-4 mb-4">
            <label for="activation-code" class="col-sm-3 col-form-label">Activation  Code</label>
            <div class="col-sm-9">
	      <input type="text" class="form-control" id="activation-code" name="activation-code" placeholder="XA03" v-model="search_params.activation_code">
            </div>
          </div>

          <div class="form-group row mt-4 mb-4">
            <label for="product-name" class="col-sm-3 col-form-label">Product Name</label>
            <div class="col-sm-9 text-left">
	      <select class="custom-select form-control size-select1" id="product-name" v-model="search_params.product_id">
                <option selected></option>
		<option v-for="option in product_list" :value="option.product_id">
		  {{ option.product_name }}
		</option>
	      </select>
            </div>
          </div>

          <div class="form-group row mt-4 mb-4">
            <label for="dateinstall" class="col-sm-3 col-form-label">Date of First Install (JST)</label>
            <div class="col-sm-9 form-inline">
	      <datepicker class="form-inline" v-model="search_params.start_date" style="display: inline-block"/>
	      <span class="ml-2 mr-2" style="padding-left: 20px; padding-right: 20px;">～</span>
	      <datepicker class="form-inline" v-model="search_params.end_date" style="display: inline-block"/>
            </div>
          </div>

          <div class="text-right">
	    <button type="button" class="greenbtnM" style="margin-right: 20px;" @click="search">Search</button>
	    <router-link to="./menu2.html"><div class="greenbtnM">Close</div></router-link>
	  </div>
	</div>
      </div>
    </form>
    
  </div>

  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import router from '../router';
import { checkMaintenance, getProductList } from '../server';
import { error } from './ErrorDialog.vue';
import moment from 'moment';

checkMaintenance();

const product_list = ref([]);

const loadProductFromServer = async() => {
    try {
	let result = await getProductList({});
	product_list.value = result.serverCurrentPageItems;
    }
    catch(e) {
	console.log(e)
    }
};

loadProductFromServer();

const search_params = ref({
    email_address: '',
    activation_code: '',
    product_id: '',
    start_date: '',
    end_date: ''
});

const search = async () => {
    let start_date = '';
    if (search_params.value.start_date) {
	start_date = moment(search_params.value.start_date).format('YYYY-MM-DD HH:mm:ss');
    }
    let end_date = '';
    if (search_params.value.end_date) {
	end_date = moment(search_params.value.end_date).format('YYYY-MM-DD HH:mm:ss');
    }
    //console.log(`start_date: `, start_date);
    //console.log(`end_date: `, end_date);
    let opts = {
	email_address: search_params.value.email_address,
	activation_code: search_params.value.activation_code,
	product_id: search_params.value.product_id,
	start_date: start_date,
	end_date: end_date
    };
    router.push({ name: 'ActivationCodeList', query: opts });
};

</script>

<style scoped>
</style>
